import { getTermsAgreementCount } from '@/pages/TermsAgreement/store/thunks';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { isDefAndNotNull } from '@/utils/def';
import { useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useTermsGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    isAuthenticated,
    permissions,
    loading: authLoading,
    sessionLoading,
    authChecked,
  } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const { data: termsAggrement, loading } = useAppSelector(
    (state) => state.termsAgreement.termsAgreementCount,
  );
  const fetchAttempted = useRef(false);

  const hasSkipAcceptTerms = useMemo(
    () =>
      Array.isArray(permissions) && permissions.includes('skip_accept_terms'),
    [permissions],
  );

  useEffect(() => {
    if (!isAuthenticated) {
      fetchAttempted.current = false;
      return;
    }

    if (authLoading || sessionLoading || !authChecked) {
      return;
    }

    if (!fetchAttempted.current && !loading) {
      dispatch(getTermsAgreementCount());
      fetchAttempted.current = true;
    }
  }, [
    isAuthenticated,
    dispatch,
    loading,
    authLoading,
    sessionLoading,
    authChecked,
  ]);

  useEffect(() => {
    if (!isAuthenticated || loading || !isDefAndNotNull(termsAggrement)) {
      return;
    }

    const whitelistedRoutes = [
      '/terms-agreement',
      '/login',
      '/profile',
      '/terms',
    ];

    const isWhitelisted = whitelistedRoutes.some((route) =>
      location.pathname.startsWith(route),
    );

    if (
      termsAggrement > 0 &&
      !hasSkipAcceptTerms &&
      !isWhitelisted &&
      location.pathname !== '/terms-agreement'
    ) {
      navigate('/terms-agreement', { replace: true });
    }
  }, [
    location.pathname,
    isAuthenticated,
    navigate,
    termsAggrement,
    loading,
    hasSkipAcceptTerms,
  ]);
}
